import React from "react";
import { VSTableBodyCellStyled, VSTableCellStyled, VSTableRowStyled } from "../../channelPage/utils/vsTableStyled";
import { useTranslation } from "react-i18next";
import localizationKeys from "../../../i18n/localizationKeys";
import { MAX_CHANNEL_COUNT } from "../../../constants/trendGraph/charts";
import { isAnalogChannel, isDigitalChannel, isDisplayedOnCustom } from "../../../constants/channel/config";
import AnalogIcon from "../../../../assets/images/custom/analog_icon.svg";
import DigitalIcon from "../../../../assets/images/custom/digital_icon.svg";
import { customChannelSelectorStyles } from "./virtualScrollTableStyle";

export const TableHeader = () => {
  const { t } = useTranslation();
  return (
    <VSTableRowStyled sx={customChannelSelectorStyles.headerHolder}>
      <VSTableCellStyled key={`custom-header-1`} width={"15%"} sx={{ borderBottom: "none" }}>
        {t(localizationKeys.CustomChannelNo)}
      </VSTableCellStyled>
      <VSTableCellStyled key={`custom-header-2`} width={"40%"} sx={{ borderBottom: "none" }}>
        {t(localizationKeys.CustomChannelName)}
      </VSTableCellStyled>
      <VSTableCellStyled key={`custom-header-3`} width={"15%"} sx={{ borderBottom: "none" }}>
        {t(localizationKeys.CustomUnit)}
      </VSTableCellStyled>
      <VSTableCellStyled key={`custom-header-4`} width={"20%"} sx={{ borderBottom: "none" }}>
        {t(localizationKeys.CustomSignalType)}
      </VSTableCellStyled>
      <VSTableCellStyled key={`custom-header-5`} width={"10%"} sx={{ borderBottom: "none" }} />
    </VSTableRowStyled>
  );
}

export const TableCustBody = (selectedChannels, channel, updateSelectedChannels) => {
  const isDisabled = selectedChannels.length >= MAX_CHANNEL_COUNT && !channel.selected;
  return (
    <>
      <VSTableBodyCellStyled component="th" scope="row" selected={channel.selected} isDisabled={isDisabled}>
        {channel.chNo}
      </VSTableBodyCellStyled>
      <VSTableBodyCellStyled align="left" selected={channel.selected} isDisabled={isDisabled}>{channel.chName}</VSTableBodyCellStyled>
      <VSTableBodyCellStyled align="left" selected={channel.selected} isDisabled={isDisabled}>{channel.unit}</VSTableBodyCellStyled>
      <VSTableBodyCellStyled align="left" selected={channel.selected} isDisabled={isDisabled}>
        {isAnalogChannel(channel?.chType)
          ? <div style={{ borderRadius: "25px", border: "1px solid rgba(250, 48, 248, 0.7)", padding: "1.5px 0 0.5px 6px", width: "72px" }}>
            <img src={AnalogIcon} style={{ marginBottom: "-4px" }} />
            <span style={{ marginLeft: "1px" }}>Analog</span>
          </div>
          : isDigitalChannel(channel?.chType)
            ? <div style={{ borderRadius: "25px", border: "1px solid rgba(132, 235, 128, 0.7)", padding: "1.5px 0 0.5px 6px", width: "72px" }}>
              <img src={DigitalIcon} style={{ marginBottom: "-4px" }} />
              <span style={{ marginLeft: "1px" }}>Digital</span>
            </div>
            : <div style={{ textAlign: "center", width: "72px" }}>
              <span>Other</span>
            </div>
        }
      </VSTableBodyCellStyled>
      <VSTableBodyCellStyled align="right" selected={channel.selected} isDisabled={isDisabled}>
        {isDisplayedOnCustom(channel.chType) ?
          <input
            type="checkbox"
            key={Math.random()}
            id={channel.chNo}
            value={channel.chNo}
            checked={channel.selected}
            data-ch-type={channel.chType}
            disabled={selectedChannels.length >= MAX_CHANNEL_COUNT && !channel.selected}
            onChange={(event) => {
              updateSelectedChannels(event.target.id, event.target.getAttribute("data-ch-type"), event.target.checked)
            }}
          />
          : null
        }
      </VSTableBodyCellStyled>
    </>
  )
};